module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "rt-link",
    on: {
      "click": _vm.click
    }
  }, [_c('el-link', _vm._b({}, 'el-link', _vm.$attrs, false), [_vm._t("default")], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3baaf0da"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-xpc/src/components/link/rtLink.vue
// module id = 2068
// module chunks = 228